import { Box, CircularProgress } from "@mui/material";

const Loading = () => (
  <Box sx={{ display: "flex", justifyContent: "center", padding: 3 }}>
    <CircularProgress />
  </Box>
);

export default Loading;
